module.exports = __webpack_public_path__ + "img/header_bg.9a633775.svg";